<div class="bg-grey-200">
  <div class="ad-skin d-none d-xl-block">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adSkinProps"
      ></flo-lazy>
  </div>
  <div class="leaderboard-center py-3 d-none d-lg-flex justify-content-center position-relative lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardLargeAdProps"
      [detectorHeight]="90"
    >
    </flo-lazy>
  </div>
  <div class="py-3 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardSmallAdProps"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <main class="container container-fluid min-vh-100 pt-md-2">
    <div class="row">
      <div class="col-12 mt-md-3 px-lg-4">
        <h1 class="h3 pb-2" data-test="results-title">Results</h1>
        <flo-event-list-controls
          [searchTerm]="searchTerm"
          [tabItems]="tabItems"
          calendarDateMode="monthly"
          (search)="handleSearch($event)"
        ></flo-event-list-controls>
      </div>
      <div class="col-12 col-lg-8 px-3 px-lg-4 border-lg-right" data-test="results-list-container">
        <ng-container *ngIf="messageModelSection">
          <div class="py-5 py-lg-5">
            <flo-no-results data-test="message-model"
              [showCurrentQuery]="messageModelSection.style === 'search:no-results'"
              [currentQueryText]="messageModelSection.title"
              [noQueryTitle]="messageModelSection.title"
              [noQueryText]="messageModelSection.text">
            </flo-no-results>
          </div>
        </ng-container>
        <ng-container *ngIf="resultsSections?.length === 0 && !messageModelSection">
          <div class="mt-4" data-test="catastrophic-error">
            <flo-error></flo-error>
          </div>
        </ng-container>
        <ng-container *ngIf="isFilterOrSearchLoading; else resultsSection">
          <div class="d-flex spinner-container" >
            <div class="spinner-border text-light d-flex m-auto"></div>
          </div>
        </ng-container>
        <ng-template #resultsSection>
          <div *ngFor="let section of resultsSections; trackBy: trackById">
            <ng-container *ngIf="section.id === 'results'">
              <ng-container *ngIf="section.items.length > 0; else zeroState">
                <div *ngFor="let item of section.items; trackBy: trackById">
                  <div
                    *ngIf="item.style === 'horizontal'"
                    class="py-3 py-lg-4 border-bottom"
                  >
                    <flo-event-card-horizontal
                      [item]="item"
                      [geoBlockedIds]="geoBlockedIds"
                    ></flo-event-card-horizontal>
                  </div>
                </div>
              </ng-container>
              <ng-template #zeroState>
                <div class="text-center pt-5 mt-md-5" data-test="no-results">
                  <ng-container *ngIf="(searchTerm && searchTerm.length > 0); else errorState">
                    <div class="mt-md-5">
                      <flo-no-results
                        data-test="no-results-component"
                        [currentQueryText]="searchTerm"
                      ></flo-no-results>
                    </div>
                  </ng-container>
                  <ng-template #errorState>
                    <flo-error></flo-error>
                  </ng-template>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </ng-template>
      </div>
      <aside
        data-test="results-right-rail"
        class="d-none d-lg-block col-lg-4 px-3 px-xl-4 pt-0"
      >
        <div class="px-xl-2 stick-to-header">
          <div
            class="
              d-none d-lg-flex
              pt-3
              justify-content-center
              lazy-flex-container
            "
          >
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="rightRailAdProps"
              [detectorHeight]="250"
            ></flo-lazy>
          </div>
        </div>
      </aside>
    </div>
  </main>
  <div class="stick-to-footer d-sm-none">
    <div class="adhesion-ad">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adhesionAdProps"
      ></flo-lazy>
    </div>
  </div>
</div>
